import styled from "@emotion/styled"

const CertificationAuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export default CertificationAuthorInfo
